import {
  CourseCertificateEnum,
  EOrderStatus,
} from '@/interfaces/training.interface';
import { ComponentPropsWithoutRef } from 'react';
import { UrlObject } from 'url';

export enum ECoursePaymentCardPlacement {
  InCart = 'InCart',
  AtFeed = 'AtFeed',
  PurchaseHistory = 'PurchaseHistory',
  CoursePayment = 'CoursePayment',
  FinishedCourse = 'FinishedCourse',
  MyCourse = 'MyCourse',
  Groups = 'Groups',
  Studying = 'Studying',
  Slider = 'Slider',
  //temporary
  InProgress = 'InProgress',
}

export interface IPaymentCardCourseDataContext {
  courseId: string;
  url: string | UrlObject;
  thumbnail?: string | null;
  title: string;
  description?: string;
  certificateShortName: CourseCertificateEnum | null;
  totalLessonCount?: number;
  requiredStudyLevel?: unknown;
  salePrice?: number;
  price?: number | null;
  totalTime?: string;
  completedDate?: string;
  completedLesson?: number;
  order?: {
    orderId: string;
    createdDate: string;
    status: EOrderStatus;
  };
  owner: {
    fullName: string | undefined;
    url: string | UrlObject | undefined;
    academicRank: string | null | undefined;
    avatar: string | null | undefined;
  };
  progress?: number;
}

export type TPaymentCardCourse = {
  placement: `${ECoursePaymentCardPlacement}`;
  dataContext: IPaymentCardCourseDataContext;
} & ComponentPropsWithoutRef<'div'>;
